import gql from 'graphql-tag'

export const GET_COMMENTS = gql`
  query getComments($uuid: ID!) {
    getRequestTicket(uuid: $uuid) {
      uuid
      comments {
        uuid
        body
        type
        commenter {
          name
          uuid
          avatar {
            cloudinaryId
            cloudinaryType
          }
        }
        createdAt
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/RequestDetailsPage/queries/get-comments.ts